import "./footer.scss";
import { Link } from "react-router-dom";
import { MessageCircle } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__content">
                <p className="footer__text">
                    © {new Date().getFullYear()} Chorulla Palli. All rights reserved.
                </p>
                <p className="footer__disclaimer">
                    Disclaimer: We are not responsible for the availability or quality of food. 
                    Please verify before starting your journey.
                </p>
                <Link to="/contact" className="footer__contact-btn">
                    <MessageCircle size={14} />
                    Contact Us
                </Link>
            </div>
        </footer>
    );
};

export default Footer;